/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {updatePaymentSchedule} from '../api'

export const useMutationUpdatePaymentSchedule = createReactQueryMutationHook('updatePaymentSchedule', updatePaymentSchedule)
